// Live-only order detail. UUIDs route to LiveOrderDetailView; non-UUID ids
// are not in the live database (mock data has been removed).
import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { LiveOrderDetailView } from "@/components/LiveOrderDetailView";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const Route = createFileRoute("/orders/$id")({
  errorComponent: ({ reset }) => (
    <AppShell>
      <div className="panel p-10 text-center">
        <p>Failed to load order.</p>
        <button onClick={reset} className="btn-primary mt-4 px-4 py-2">Try again</button>
      </div>
    </AppShell>
  ),
  notFoundComponent: () => (
    <AppShell><div className="panel p-10 text-center">Order not found.</div></AppShell>
  ),
  component: OrderRouteEntry,
});

function OrderRouteEntry() {
  const { id } = Route.useParams();
  if (!UUID_RE.test(id)) {
    return (
      <AppShell>
        <div className="panel p-10 text-center text-sm text-muted-foreground">
          This order does not exist.
        </div>
      </AppShell>
    );
  }
  return <LiveOrderDetailView id={id} />;
}
